import { IDataReaderClient } from "@multiweb/clients/dataReader";
import { ClientType, IClientFactory } from "@multiweb/clients/index";
import { IModelDescriptionsClient } from "@multiweb/clients/modelDescriptions";
import { DIContainer } from "Global/Base/DIContainer";

/**
 * Získá klienta pro čtení dat z DIContainer.
 *
 * @deprecated Komponenty by si neměly samy získávat implementace z DIContaineru. Implementace by jim měly být poskytnuty zvenčí. Viz task 27816.
 */
export const getDataReaderClient = (): IDataReaderClient => DIContainer.instance.create(IClientFactory).get(ClientType.dataReader);

/**
 * Získá klienta pro čtení informací o modelu z DIContainer.
 *
 * @deprecated Komponenty by si neměly samy získávat implementace z DIContaineru. Implementace by jim měly být poskytnuty zvenčí. Viz task 27816.
 */
export const getModelDescriptionsClient = (): IModelDescriptionsClient => DIContainer.instance.create(IClientFactory).get(ClientType.modelDescriptions);
